import styled from 'styled-components';
import { Button } from '../index';

export const ModalContent = styled.div`
  width: min(980px, 92vw);
  max-height: 88vh;
  overflow-y: auto;
  background: ${props => props.theme.colors.white};
  border-radius: ${props => props.theme.radii.md};
  padding: ${props => props.theme.spacing.xl};
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.lg};
  box-shadow: ${props => props.theme.shadows.md};
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.xs};
`;

export const Title = styled.h2`
  margin: 0;
  color: ${props => props.theme.colors.textPrimary};
  font-size: ${props => props.theme.typography.sizes.xl};
`;

export const Subtitle = styled.p`
  margin: 0;
  color: ${props => props.theme.colors.textSecondary};
  font-size: ${props => props.theme.typography.sizes.sm};
`;

export const TableWrapper = styled.div`
  border: 1px solid ${props => props.theme.colors.border};
  border-radius: ${props => props.theme.radii.sm};
  overflow: hidden;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;

  th,
  td {
    padding: ${props => props.theme.spacing.md};
    text-align: left;
    vertical-align: top;
    border-bottom: 1px solid ${props => props.theme.colors.border};
  }

  th {
    background: ${props => props.theme.colors.background};
    color: ${props => props.theme.colors.textSecondary};
    font-size: ${props => props.theme.typography.sizes.xs};
    letter-spacing: 0.04em;
    text-transform: uppercase;
  }

  tr:last-child td {
    border-bottom: none;
  }
`;

export const DiffText = styled.p`
  margin: 0;
  color: ${props => props.theme.colors.textSecondary};
  font-size: ${props => props.theme.typography.sizes.xs};
  line-height: ${props => props.theme.typography.lineHeights.md};
`;

export const DiffPathList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${props => props.theme.spacing.xxs};
`;

export const DiffPathTag = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 2px ${props => props.theme.spacing.xs};
  border: 1px solid ${props => props.theme.colors.border};
  border-radius: ${props => props.theme.radii.pill};
  background: ${props => props.theme.colors.background};
  color: ${props => props.theme.colors.textSecondary};
  font-size: ${props => props.theme.typography.sizes.xs};
`;

export const ChangeTypeTag = styled.span<{
  $tone?: 'neutral' | 'success' | 'danger' | 'warning';
}>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 90px;
  padding: ${props => props.theme.spacing.xxs}
    ${props => props.theme.spacing.sm};
  border-radius: ${props => props.theme.radii.pill};
  border: 1px solid
    ${props => {
      if (props.$tone === 'success') return props.theme.colors.success;
      if (props.$tone === 'danger') return props.theme.colors.danger;
      if (props.$tone === 'warning') return props.theme.colors.warning;

      return props.theme.colors.border;
    }};
  color: ${props => {
    if (props.$tone === 'success') return props.theme.colors.success;
    if (props.$tone === 'danger') return props.theme.colors.danger;
    if (props.$tone === 'warning') return props.theme.colors.warning;

    return props.theme.colors.textPrimary;
  }};
  background: ${props => props.theme.colors.surface};
  text-transform: uppercase;
  font-size: ${props => props.theme.typography.sizes.xs};
  font-weight: ${props => props.theme.typography.weights.semibold};
`;

export const Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: ${props => props.theme.spacing.md};
`;

export const PaginationInfo = styled.p`
  margin: 0;
  color: ${props => props.theme.colors.textSecondary};
  font-size: ${props => props.theme.typography.sizes.sm};
`;

export const PaginationActions = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sm};
`;

export const ActionButton = styled(Button).attrs({
  variant: 'outline',
  size: 'sm'
})``;

export const PrimaryButton = styled(Button).attrs({
  variant: 'secondary',
  size: 'sm'
})``;

export const EmptyState = styled.div`
  border: 1px dashed ${props => props.theme.colors.border};
  border-radius: ${props => props.theme.radii.sm};
  padding: ${props => props.theme.spacing.xl};
  text-align: center;
  color: ${props => props.theme.colors.textMuted};
`;

export const ErrorState = styled(EmptyState)`
  color: ${props => props.theme.colors.danger};
`;
